import styled, {css} from 'styled-components';
import {ReportSection} from '../../ReportSection';

export const PanelGridWrapper = styled.div``;

export const PanelGrid = styled(ReportSection)<{selected: boolean}>`
  margin-top: 12px !important;
  white-space: normal;
  ${props =>
    !props.readOnly &&
    css`
      .grid-section-wrapper {
        cursor: pointer;
        &:hover {
          .grid-dot {
            background: #c9c9c9;
          }
        }
      }
    `}

  .grid-section-wrapper,
  .run-sets-wrapper {
    padding: 0 !important;
  }
  ${props =>
    props.selected &&
    css`
      .editable-panel,
      .run-sets-wrapper.active .run-sets,
      .run-sets-wrapper:not(.active) .run-set-summary {
        box-shadow: 0 0 0 6px rgb(208, 225, 252);
        transition: none;
      }
      .grid-dot {
        background: rgb(178, 195, 232);
      }
    `}
`;
